import { RootState } from '..';

export const consultantSelector = (state: RootState) => state.consultant;
